import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import api, { clearAccessToken } from "../api/api";
import {
  clearProfileCache,
  getProfileCached,
  subscribeProfileCache,
} from "../api/profileApi";
import MobileMenu from "./MobileMenu";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [profile, setProfile] = useState({
    first_name: "",
    last_name: "",
    profile_image_url: ""
  });
  const navigate = useNavigate();
  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}

    clearAccessToken();
    clearProfileCache();
    localStorage.removeItem("hasProfessionalProfile");
    sessionStorage.clear();
  
    navigate("/login", { replace: true });
  };

  useEffect(() => {
    let mounted = true;
    const applyProfile = (data = {}) => {
      if (!mounted) return;
      setProfile({
        first_name: data.first_name || "",
        last_name: data.last_name || "",
        profile_image_url: data.profile_image_url || ""
      });
    };

    const unsubscribe = subscribeProfileCache((data) => {
      applyProfile(data || {});
    });

    getProfileCached()
      .then((res) => {
        applyProfile(res.data || {});
      })
      .catch(() => {});
    return () => {
      mounted = false;
      unsubscribe();
    };
  }, []);

  const fullName = [profile.first_name, profile.last_name].filter(Boolean).join(" ").trim();
  const shortName = profile.first_name || fullName || "User";
  const avatarUrl = profile.profile_image_url || "/images/profile.png";
  return (
    <header className="header-menu d-flex align-items-center justify-content-between">
      <Link to="/dashboard" className="mobile-logo d-lg-none">
        <img
          src="/images/skedq.png"
          alt="Logo"
          className="img-fluid"
          style={{ height: "40px" }}
        />
      </Link>

    <div className="d-flex gap-3 ms-auto align-items-center">
      <div className="profile-dropdown">
        <button
          className="profile-btn"
          onClick={() => setOpen(!open)}
        >
          <img
            src={avatarUrl}
            className="avatar"
            alt="profile"
          />
          <span>{shortName}</span>
          <i className="bi bi-caret-down-fill"></i>
        </button>

        {open && (
          <div className="dropdown-card">
            <div className="dropdown-header">
              Full Name
              <span>{fullName || "User"}</span>
            </div>

            <ul>
              <li><Link to="/dashboard">Dashboard</Link></li>
              <li><Link to="/profile">Account Settings</Link></li>
              <li>
                <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      logout();
                    }}
                >
                    Log Out
                    </a>
                </li>
            </ul>
          </div>
        )}
      </div>

     <MobileMenu /> 
    </div>
    </header>
  );
}
